module.exports = __webpack_public_path__ + "static/media/bird_goelys.4ca657bd.svg";